"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SharedReports = void 0;
const T = __importStar(require("@microsoft/fast-element"));
const fast_element_1 = require("@microsoft/fast-element");
require("./template.html");
const client_1 = require("@rws-framework/client");
const component_1 = require("@front/components/notifications/component");
//@ts-ignore                
let rwsTemplate = T.html `<div class="shared-reports-container">
    <div class="page-header">
        <h1>${'reports.shared.title'.t()}</h1>
        <p class="page-subtitle">${'reports.shared.description'.t()}</p>
    </div>

    ${(0, fast_element_1.when)(x => x.loading, (0, fast_element_1.html) `
    <div class="loading-container">
        <div class="loading-spinner"></div>
        <span>${'common.loading'.t()}</span>
    </div>
    `)}

    ${(0, fast_element_1.when)(x => !x.loading && x.error, (0, fast_element_1.html) `
    <div class="error-container">
        <i class="fas fa-exclamation-triangle"></i>
        <span>${x => x.error}</span>
        <button @click="${x => x.loadSharedConversations()}" class="btn btn-primary">
            ${'reports.shared.retryButton'.t()}
        </button>
    </div>
    `)}

    ${(0, fast_element_1.when)(x => !x.loading && !x.error && x.conversations.length === 0, (0, fast_element_1.html) `
    <div class="empty-state">
        <i class="fas fa-share-alt"></i>
        <h3>${'reports.shared.empty.title'.t()}</h3>
        <p>${'reports.shared.empty.description'.t()}</p>
    </div>
    `)}

    ${(0, fast_element_1.when)(x => !x.loading && !x.error && x.conversations.length > 0, (0, fast_element_1.html) `
    <div class="conversations-grid">
        ${(0, fast_element_1.repeat)(x => x.conversations, (0, fast_element_1.html) `
            <div class="conversation-card">
                <div class="conversation-header">
                    <h3 class="conversation-title">${x => x.title}</h3>
                    <div class="conversation-owner">
                        <i class="fas fa-user"></i>
                        <span>${(x, c) => c.parent.getOwnerName(x)}</span>
                    </div>
                </div>

                <div class="conversation-details">
                    <div class="conversation-meta">
                        <div class="meta-item">
                            <span class="meta-label">${'reports.shared.createdAt'.t()}:</span>
                            <span class="meta-value">${(x, c) => c.parent.formatDate(x.created_at)}</span>
                        </div>
                        <div class="meta-item">
                            <span class="meta-label">${'reports.shared.lastActivity'.t()}:</span>
                            <span class="meta-value">${(x, c) => c.parent.formatDate(x.lastActivity)}</span>
                        </div>
                    </div>

                    ${(0, fast_element_1.when)(x => x.model, (0, fast_element_1.html) `
                    <div class="conversation-model">
                        <span class="model-label">${'reports.shared.model'.t()}:</span>
                        <span class="model-name">${x => { var _a; return ((_a = x.model) === null || _a === void 0 ? void 0 : _a.name) || 'reports.shared.unknownModel'.t(); }}</span>
                    </div>
                    `)}
                </div>

                <div class="shared-users">
                    <span class="shared-label">${'reports.shared.sharedWith'.t()}:</span>
                    <span class="shared-list">${(x, c) => c.parent.formatSharedUsers(x.sharedUsers)}</span>
                </div>
            </div>
            `)}
    </div>
    `)}
</div>`;
require("./styles/layout.scss");
const styles = T.css `.shared-reports-container {
  padding: 2rem;
  max-width: 1200px;
  margin: 0 auto;
}
.shared-reports-container .page-header {
  margin-bottom: 2rem;
  text-align: center;
}
.shared-reports-container .page-header h1 {
  font-size: 2.5rem;
  color: var(--text-primary);
  margin-bottom: 0.5rem;
}
.shared-reports-container .page-header .page-subtitle {
  color: var(--text-secondary);
  font-size: 1.1rem;
  margin: 0;
}
.shared-reports-container .loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 3rem;
  text-align: center;
}
.shared-reports-container .loading-container .loading-spinner {
  width: 40px;
  height: 40px;
  border: 3px solid var(--border-color);
  border-top: 3px solid var(--primary-color);
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 1rem;
}
.shared-reports-container .loading-container span {
  color: var(--text-secondary);
  font-size: 1.1rem;
}
.shared-reports-container .error-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 3rem;
  text-align: center;
  background: var(--error-bg, #fef2f2);
  border: 1px solid var(--error-border, #fecaca);
  border-radius: 8px;
}
.shared-reports-container .error-container i {
  font-size: 3rem;
  color: var(--error-color, #dc2626);
  margin-bottom: 1rem;
}
.shared-reports-container .error-container span {
  color: var(--error-text, #991b1b);
  font-size: 1.1rem;
  margin-bottom: 1.5rem;
}
.shared-reports-container .empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 4rem;
  text-align: center;
}
.shared-reports-container .empty-state i {
  font-size: 4rem;
  color: var(--text-muted);
  margin-bottom: 1.5rem;
}
.shared-reports-container .empty-state h3 {
  color: var(--text-primary);
  margin-bottom: 1rem;
  font-size: 1.5rem;
}
.shared-reports-container .empty-state p {
  color: var(--text-secondary);
  font-size: 1.1rem;
  max-width: 400px;
  line-height: 1.6;
}
.shared-reports-container .conversations-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(400px, 1fr));
  gap: 1.5rem;
  margin-top: 2rem;
}
.shared-reports-container .conversations-grid .conversation-card {
  background: var(--card-bg, #ffffff);
  border: 1px solid var(--border-color);
  border-radius: 12px;
  padding: 1.5rem;
  transition: all 0.2s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
.shared-reports-container .conversations-grid .conversation-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}
.shared-reports-container .conversations-grid .conversation-card .conversation-header {
  margin-bottom: 1rem;
}
.shared-reports-container .conversations-grid .conversation-card .conversation-header .conversation-title {
  font-size: 1.3rem;
  color: var(--text-primary);
  margin: 0 0 0.5rem 0;
  font-weight: 600;
  line-height: 1.4;
}
.shared-reports-container .conversations-grid .conversation-card .conversation-header .conversation-owner {
  display: flex;
  align-items: center;
  color: var(--text-secondary);
  font-size: 0.95rem;
}
.shared-reports-container .conversations-grid .conversation-card .conversation-header .conversation-owner i {
  margin-right: 0.5rem;
  color: var(--primary-color);
}
.shared-reports-container .conversations-grid .conversation-card .conversation-details {
  margin-bottom: 1.5rem;
}
.shared-reports-container .conversations-grid .conversation-card .conversation-details .conversation-meta {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin-bottom: 1rem;
}
.shared-reports-container .conversations-grid .conversation-card .conversation-details .conversation-meta .meta-item {
  display: flex;
  justify-content: space-between;
  font-size: 0.9rem;
}
.shared-reports-container .conversations-grid .conversation-card .conversation-details .conversation-meta .meta-item .meta-label {
  color: var(--text-secondary);
  font-weight: 500;
}
.shared-reports-container .conversations-grid .conversation-card .conversation-details .conversation-meta .meta-item .meta-value {
  color: var(--text-primary);
}
.shared-reports-container .conversations-grid .conversation-card .conversation-details .conversation-model {
  background: var(--info-bg, #f0f9ff);
  border: 1px solid var(--info-border, #bae6fd);
  border-radius: 6px;
  padding: 0.75rem;
  font-size: 0.9rem;
}
.shared-reports-container .conversations-grid .conversation-card .conversation-details .conversation-model .model-label {
  color: var(--text-secondary);
  font-weight: 500;
  margin-right: 0.5rem;
}
.shared-reports-container .conversations-grid .conversation-card .conversation-details .conversation-model .model-name {
  color: var(--info-text, #0369a1);
  font-weight: 600;
}
.shared-reports-container .conversations-grid .conversation-card .shared-users {
  margin-top: 1rem;
  padding-top: 0.75rem;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
  font-size: 0.9rem;
}
.shared-reports-container .conversations-grid .conversation-card .shared-users .shared-label {
  font-weight: 600;
  color: var(--text-secondary);
  margin-right: 0.5rem;
}
.shared-reports-container .conversations-grid .conversation-card .shared-users .shared-list {
  color: var(--text-primary);
  font-style: italic;
}
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
@media (max-width: 768px) {
  .shared-reports-container {
    padding: 1rem;
  }
  .shared-reports-container .page-header h1 {
    font-size: 2rem;
  }
  .shared-reports-container .conversations-grid {
    grid-template-columns: 1fr;
    gap: 1rem;
  }
  .shared-reports-container .conversations-grid .conversation-card {
    padding: 1rem;
  }
  .shared-reports-container .conversations-grid .conversation-card .conversation-meta .meta-item {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.2rem;
  }
}`;
const shadowOptions = { "mode": "open" };
let SharedReports = class SharedReports extends client_1.RWSViewComponent {
    constructor() {
        super(...arguments);
        this.loading = false;
        this.conversations = [];
        this.error = '';
    }
    async connectedCallback() {
        super.connectedCallback();
        await this.loadSharedConversations();
    }
    async loadSharedConversations() {
        try {
            this.loading = true;
            this.error = '';
            const response = await this.apiService.back.get('reports.shared_conversations');
            if (response && response.success && Array.isArray(response.data)) {
                this.conversations = response.data;
            }
            else {
                this.error = (response === null || response === void 0 ? void 0 : response.error) || 'reports.shared.failedToLoad'.t();
                component_1.NotificationsArea.sendNotification({
                    content: this.error,
                    type: 'error'
                });
            }
        }
        catch (e) {
            console.error('Error loading shared conversations:', e);
            this.error = 'reports.shared.failedToLoad'.t();
            component_1.NotificationsArea.sendNotification({
                content: this.error,
                type: 'error'
            });
        }
        finally {
            this.loading = false;
        }
    }
    formatDate(date) {
        const dateObj = typeof date === 'string' ? new Date(date) : date;
        return dateObj.toLocaleDateString() + ' ' + dateObj.toLocaleTimeString();
    }
    getOwnerName(conversation) {
        var _a, _b;
        return ((_a = conversation.user) === null || _a === void 0 ? void 0 : _a.name) || ((_b = conversation.user) === null || _b === void 0 ? void 0 : _b.username) || 'reports.shared.unknownUser'.t();
    }
    formatSharedUsers(users) {
        if (!users || users.length === 0) {
            return 'reports.shared.noUsers'.t();
        }
        const userNames = users.map(user => user.name || user.username);
        if (userNames.length === 1) {
            return userNames[0];
        }
        else if (userNames.length === 2) {
            return `${userNames[0]} ${'and'.t()} ${userNames[1]}`;
        }
        else {
            return `${userNames.slice(0, -1).join(', ')}, ${'and'.t()} ${userNames[userNames.length - 1]}`;
        }
    }
};
exports.SharedReports = SharedReports;
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], SharedReports.prototype, "loading", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], SharedReports.prototype, "conversations", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], SharedReports.prototype, "error", void 0);
exports.SharedReports = SharedReports = __decorate([
    (0, client_1.RWSView)('shared-reports', null, { template: rwsTemplate, styles, options: { shadowOptions } })
], SharedReports);
SharedReports.defineComponent();
